export enum AuroraHeatPumpStatus {
  ON = 1,
  OFF = 0
}

export default AuroraHeatPumpStatus
